module.exports = __webpack_public_path__ + "img/user-2.7ab25b11.jpg";